"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationBarContext = void 0;

var _react = require("react");

/**
 * SPDX-FileCopyrightText: © 2022 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var NavigationBarContext = /*#__PURE__*/(0, _react.createContext)({
  ariaCurrent: 'page'
});
exports.NavigationBarContext = NavigationBarContext;